import React from "react";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";

const Crumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  return (
    <Breadcrumbs separator="›" aria-label="breadcrumb">
      {pathnames.map((value, index) => {

        const last = index === pathnames.length - 1;
        const to = `/${pathnames.slice(0, index + 1).join("/")}`;
        const name =
          value.charAt(0).toUpperCase() + value.slice(1).replace(/-/g, " ");

        return last ? (
          <Typography
            color="text.primary"
            key={index}
            variant="body2"
            fontSize={14}
            display={"flex"}
          >
            {value === "dashboard" && (
              <HomeIcon sx={{ mr: 0.5 }} fontSize="small" />
            )}
            {name}
          </Typography>
        ) : (
          <Link
            component={RouterLink}
            underline="hover"
            color="inherit"
            to={to}
            key={index}
            replace={true}
          >
            <Typography
              color="text.secondary"
              key={index}
              variant="body2"
              fontSize={14}
              display={"flex"}
            >
              {value === "dashboard" && (
                <HomeIcon sx={{ mr: 0.5 }} fontSize="small" />
              )}
              {name}
            </Typography>
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default Crumbs;
